import {
  Input,
  MultiSearchForm,
  useDebouncedSearch,
  useEffect,
  useRef,
  useState,
} from "@";
import { getGiftProjects } from "../api/api";
import { searchValues } from "../lib/options";
import type { MultiSearchProps, SearchValues } from "../types";

interface GiftProjectOption {
  value: string;
  label: string;
}

const MultiSearch = ({
  onSubmit,
  onReset,
  search,
  updateSearch,
  dataLength,
}: MultiSearchProps) => {
  const hasFetchedData = useRef(false);
  const [giftProjects, setGiftProjects] = useState<GiftProjectOption[]>([]);
  useDebouncedSearch(onSubmit, search.values, searchValues);

  async function fetchGiftProjects() {
    const data = await getGiftProjects();
    setGiftProjects(data);
  }

  const handleInputChange = (
    field: keyof SearchValues,
    value: string | number | null,
  ) => {
    updateSearch({
      values: { ...search.values, [field]: value ?? "" },
    });
  };

  useEffect(() => {
    if ((dataLength ?? 0) > 0 && !hasFetchedData.current) {
      fetchGiftProjects();
      hasFetchedData.current = true;
    }
  }, [dataLength]);

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-6"
      reset={onReset}
    >
      <>
        <Input
          star
          label="إسم المتبرع "
          style="lg:col-span-2"
          value={search.values.customerName}
          change={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("customerName", e.target.value)
          }
        />

        <Input
          star
          type="select"
          label="حالة التصميم"
          list={[
            { value: 0, title: "نجاح" },
            { value: 1, title: "فشل" },
          ]}
          value={search.values.giftProjectOrderItemDesignStatus}
          change={(e: React.ChangeEvent<HTMLSelectElement>) =>
            handleInputChange(
              "giftProjectOrderItemDesignStatus",
              e.target.value,
            )
          }
        />

        <Input
          star
          label="هاتف المتبرع"
          value={search.values.customerPhone}
          change={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("customerPhone", e.target.value)
          }
        />

        <Input
          star
          label="المشروع"
          list={giftProjects}
          style="lg:col-span-2"
          type="select-searchable"
          value={giftProjects?.filter(
            (c) => search.values.giftProjectName == c.value,
          )}
          change={(e: GiftProjectOption | null) =>
            handleInputChange("giftProjectName", e ? e.value : null)
          }
        />

        <Input
          star
          showTimeSelect
          type="date-range"
          labelA="من تاريخ"
          labelB="الي تاريخ"
          style="lg:col-span-2"
          valueB={search.values.toDate}
          valueA={search.values.fromDate}
          changeB={(e: string) => handleInputChange("toDate", e)}
          changeA={(e: string) => handleInputChange("fromDate", e)}
        />

        <Input
          star
          label="إسم المرسل "
          value={search.values.giftSenderName}
          change={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("giftSenderName", e.target.value)
          }
        />

        <Input
          star
          label="إسم المهدي إليه"
          value={search.values.giftReceiverName}
          change={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("giftReceiverName", e.target.value)
          }
        />

        <Input
          star
          label="هاتف المهدي إليه"
          value={search.values.giftReceiverPhone}
          change={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("giftReceiverPhone", e.target.value)
          }
        />
      </>
    </MultiSearchForm>
  );
};

export default MultiSearch;
